import type { AgentSkillCard } from '@/libs/agent-skills-data';

export type HomepageProduct = {
  id: number;
  product_intl?: Array<{
    title: string;
    desc: string;
    content?: string;
    name: string;
  }>;
  link: string;
  screenshot: string | null;
  name: string;
  category_name: string;
  category_slug: string;
  created_at: string;
  updated_at: string;
  slug: string;
  featured?: number;
  title?: string;
  description?: string;
};

export type HomepageCategory = {
  id: number;
  category_name: string;
  slug: string;
  emoji: string;
};

export type HomepageNewsItem = {
  id: string;
  slug: string | null;
  title: string;
  source_name: string | null;
  published_at: string;
  category: string | null;
};

export type HomepageFaqItem = {
  question: string;
  answer: string;
};

export type HomepageAd = {
  id: number;
  slot: number;
  product: HomepageProduct;
};

export type HomepageEditorialData = {
  homepageAds: HomepageAd[];
  featuredProducts: HomepageProduct[];
  regularProducts: HomepageProduct[];
  categories: HomepageCategory[];
  skills: AgentSkillCard[];
  news: HomepageNewsItem[];
  faq: HomepageFaqItem[];
};

export function productName(product: HomepageProduct): string {
  return product.product_intl?.[0]?.name || product.name;
}

export function productTitle(product: HomepageProduct): string {
  return product.product_intl?.[0]?.title || product.title || '';
}

export function productDescription(product: HomepageProduct): string {
  return product.product_intl?.[0]?.desc || product.description || productTitle(product);
}
